import { tv } from 'tailwind-variants';

import styles from './Card.module.css';

const card = tv({
  base: `
  block
  p-5
  xs:p-3
  rounded-md
  shadow-lg
  w-full
  `,
  variants: {
    color: {
      primary: 'bg-white',
      secondary: 'bg-indigo-50 bg-opacity-50'
    },
    outline: {
      true: 'border border-slate-300'
    },
    shadow: {
      false: 'shadow-none'
    }
  }
});

type Props = React.InputHTMLAttributes<HTMLDivElement> & {
  backgroundColor?: string;
  borderEffect?: string;
  children: React.ReactNode;
  color?: 'primary' | 'secondary';
  outline?: boolean;
  shadow?: boolean;
};

const Card: React.FC<Props> = ({
  backgroundColor = '#212B36',
  borderEffect = '',
  color,
  children,
  outline,
  shadow,
  ...props
}) => {
  return (
    <div
      className={`bg-[${backgroundColor}] ${card({ color, outline, shadow })} ${borderEffect && styles[borderEffect]}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
